<template>
  <div class="actions">
    <h1>Actions</h1>
    <div id="main">
      <el-button @click="goto('user_info')" icon="el-icon-search">Parent/Child info</el-button>
      <el-button @click="goto('send_notifications')">Send Notifications</el-button>
      <!-- <el-button @click="goto('reset_password')">Reset Password</el-button> -->
      <el-button @click="goto('verify_notices')">Verify Notices</el-button>
      <el-button @click="goto('csv_snapshot')">csv snapshot</el-button>

      <!-- <el-button @click="goto('send_service_emails')" disabled="true" title="Moved to Automations"
        >Send Service Emails</el-button
      >
      <el-button @click="goto('send_login_emails')" disabled="true" title="Moved to Automations"
        >Send Login Emails</el-button
      > -->
      <!-- <el-button @click="goto('send_admin_messages')"
        >Send Admin Messages</el-button
      > -->
      <h4>School actions</h4>
      <el-button @click="gotoRoute('/members/school_integrations')">Wonde integration & data</el-button>
      <el-button @click="goto('disable_school')">Disable school</el-button>
    </div>

    <h4>Once a term</h4>
    <!-- <el-button size="small" @click="goto('new_term')" disabled="true" title="Moved to Automations">New Term</el-button>
    <el-button size="small" @click="goto('move_children_up_a_year')" disabled="true" title="Moved to Automations"
      >Move children up a year</el-button
    >
    <el-button size="small" @click="goto('remove_user_schools')" disabled="true" title="Moved to Automations"
      >Remove User Schools</el-button
    >
    <el-button size="small" @click="goto('remove_non_user_data')" disabled="true" title="Moved to Automations"
      >Remove Non User Data</el-button
    > -->
    <el-button size="small" @click="goto('change_school_and_year')">Change School and Year</el-button>
    <h4>Stap data</h4>
    <el-button size="small" @click="goto('stap_journey_count')">STEP Journey Sharing</el-button>
    <h4>Cache related</h4>
    <el-select size="small" v-model="cache_type" placeholder="Select cache type">
      <el-option v-for="item in cache_types" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
    <el-button size="small" @click="clearCache">Clear cache</el-button>
  </div>
</template>
<style lang="scss" scoped>
#main button {
  min-width: 150px;
}

button {
  // line-height: 25px;
  margin-bottom: 10px;
}
</style>
<script>
import ApiService from "@/services/ApiService";
export default {
  data() {
    return {
      cache_type: "",
      cache_types: [
        { label: "Journeys cache", value: "journeys_cache" },
        { label: "Step api cache", value: "step_api_cache" },
        { label: "Map cache", value: "map_cache" },
      ],
    };
  },
  methods: {
    goto(path) {
      path = "actions/" + path;
      this.$router.push(path);
    },
    gotoRoute(fullPath) {
      this.$router.push(fullPath);
    },
    clearCache() {
      ApiService.sadminApi.clearCache(this.cache_type).then((resp) => {
        if (resp.data.cache_entries_removed || resp.status === 200) {
          this.$message.success("Cache cleared successfully. " + resp.data.cache_entries_removed + " items cleared");
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
};
</script>
